// Cookie read by every *.crowncoinscasino.com surface (dev router, backend, game-ui)
// to route requests to the debug env — same name the value used to ride as a header.
export const DEBUG_ENV_COOKIE = 'x-debug';
export const GEO_HEADER = 'cf-ipcountry';
// Geo override headers read by player-backend's geoOverride (gated there by the
// region_block_geo_override flag) — the same pair the mobile debug console sends.
export const GEO_COUNTRY_OVERRIDE_HEADER = 'x-country-override';
export const GEO_REGION_OVERRIDE_HEADER = 'x-region-override';
// `true` keeps the `x-geo-coords` GPS fix in play on top of the override; ignored by default.
export const GEO_USE_GPS_HEADER = 'x-geo-override-use-gps';

// localStorage keys (non-cookie state).
export const LS_GEO = 'debug-geo';
export const LS_GEO_STATE = 'debug-geo-state';
export const LS_GEO_USE_GPS = 'debug-geo-use-gps';
export const LS_GEO_COORDS = 'debug-geo-coords';
export const LS_INDICATOR = 'debug-indicator';
export const LS_ANALYTICS_ALERTS = 'debug-analytics-alerts';
export const LS_SUPPRESS_MARKETING = 'debug-suppress-marketing';
export const LS_COLLAPSED_SECTIONS = 'debug-collapsed-sections';

// PR deploy cookies routing a per-PR build. admin_pr is intentionally omitted:
// the admin app is a separate surface (admin.dev.crowncoinscasino.com) and not
// routed from the player frontend.
export const PR_COOKIES: { name: string }[] = [{ name: 'player_pr' }, { name: 'securepay_pr' }, { name: 'game_pr' }];

// Slug must match the dev Caddy regex: first char a letter, then [a-z0-9], 4–31 chars.
export const SLUG_REGEX = /^[a-z][a-z0-9]{3,30}$/;

// Geo override options ('' = Off → no header).
export const GEO_OPTIONS: { label: string; value: string }[] = [
  { label: 'Off', value: '' },
  { label: 'USA', value: 'US' },
  { label: 'NZ', value: 'NZ' },
  { label: 'Canada', value: 'CA' },
  { label: 'Germany', value: 'DE' },
  { label: 'Austria', value: 'AT' },
];

// How many analytics events the Analytics Alerts toasts keep around.
export const MAX_ANALYTICS_ALERTS = 20;
